module.exports = __webpack_public_path__ + "img/ielts_logo.2681e92c.jpg";